import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  saveButton: {
    alignSelf: 'center',
    width: 210,
    borderRadius: 10,
    marginTop: theme.spacing(3)
  },
  addInstallment: {
    textDecoration: 'underline',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    fontSize: '.875rem'
  },
  installmentContainer: {
    display: 'flex',
    flexDirection: 'column'
  }
}))
